import React, { useState } from 'react';
import { supabase } from '../../utils/supabase';
import { ResetPasswordFormProps } from './types';
import './styles.scss';

const MIN_LENGTH = 6;

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ setAuthView, onComplete }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < MIN_LENGTH) {
      setError(`Password must be at least ${MIN_LENGTH} characters.`);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('The two passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      // The recovery link has already put us in a recovery session, so
      // updateUser can set the password without the old one.
      const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
      if (updateError) throw updateError;
      setSuccess(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="success-screen">
        <div className="success-icon">✓</div>
        <h2>Password Updated</h2>
        <p>You can now sign in with your new password.</p>
        <button onClick={onComplete} className="btn btn-primary">
          Continue
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Choose a New Password</h2>
      <p className="auth-subtitle">Enter a new password for your account</p>

      {error && <div className="error-message">{error}</div>}

      <div className="form-content">
        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="form-input"
          autoComplete="new-password"
          required
        />
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="form-input"
          autoComplete="new-password"
          required
        />
        <p className="reset-hint">At least {MIN_LENGTH} characters.</p>

        <button type="submit" disabled={loading} className="btn btn-primary btn-large">
          {loading ? 'Updating...' : 'Update Password'}
        </button>
        <button type="button" onClick={() => setAuthView('login')} className="btn btn-secondary">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
